var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['form-element', _vm.hidden && 'd-none']},[(_vm.label)?_c('FormLabel',_vm._b({},'FormLabel',{
      label: _vm.label,
      required: _vm.required,
      disabled: _vm.disabled,
      description: _vm.description,
      descriptionType: _vm.descriptionType,
      dirty: _vm.dirty,
      error: _vm.error,
      id: _vm.id
    },false)):_vm._e(),_c('div',{staticClass:"d-flex"},[_c('input',{staticClass:"slider flex-1",attrs:{"id":_vm.id,"type":"range","min":_vm.mergedConfig.min,"max":_vm.mergedConfig.max,"disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.update($event.target.value)}}}),(_vm.mergedConfig.showValue)?_c('small',{staticClass:"form-range__value text-muted ml-2"},[_vm._v("\n      "+_vm._s(_vm.value)+"\n    ")]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }